module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/noop-loader!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html
// module id = ../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html
// module chunks = 0